import { useEffect } from 'react';

const DynamicFavicon = () => {
  useEffect(() => {
    const clientID = import.meta.env.VITE_CLIENT_ID;
    const faviconPath = clientID === 'default' 
      ? '/favicon/airplate-favicon.ico'  // Path to AirPlate favicon
      : clientID === 'aerofence'
        ? '/favicon/aerofence-favicon.ico'
        : '/favicon/mydefence-favicon.ico';   // Path to client favicon

    // Update favicon link element
    const favicon = document.querySelector("link[rel='icon']") as HTMLLinkElement;
    if (favicon) {
      favicon.href = faviconPath;
    } else {
      // Create new favicon link if it doesn't exist
      const newFavicon = document.createElement('link');
      newFavicon.rel = 'icon';
      newFavicon.href = faviconPath;
      document.head.appendChild(newFavicon);
    }
  }, []);

  return null;
};

export default DynamicFavicon; 